import type { UIMessage } from "ai";

export type LimeAiMessageMetadata = {
  /** Emitted by the server on the stream's `start` event; keys a rating. */
  requestId?: string;
};

/**
 * Tool parts arrive as `dynamic-tool` for now: the client does not import the
 * server's tool set, so inputs and outputs are `unknown` until the server
 * exports its types.
 */
export type LimeAiUIMessage = UIMessage<LimeAiMessageMetadata>;

export const AI_CHAT_PANEL_ID = "lime-ai-chat-panel";
